"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nave": {
    "87962f51": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "skipSearch": false
    }],
    "dernago": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9cd97feb": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "skipSearch": false
    }],
    "mitria": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25b03f4d": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "skipSearch": false
    }],
    "monteclana": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f0f3015": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "skipSearch": false
    }],
    "muratello": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2443034": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "skipSearch": false
    }],
    "sassiva": [{
      "hkey": "785c0568",
      "slug": "nave",
      "name": "Nave",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;